import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@fluentui/react';
import { Button } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getActionBarStyles } from './style/action-bar-style';

export const ActionBar = ({
  onAdd,
  onCancel,
}) => {
  const classes = useDefaultStyles(getActionBarStyles);
  const i18n = useContext(I18nContext);

  return (
    <div className={`${classes.root} action-bar`}>
      <Stack horizontal tokens={{ childrenGap: 12 }}>
        <Stack.Item key="add-button">
          <Button appearance="primary" onClick={onAdd}>{i18n.getString(_TL_('Add'))}</Button>
        </Stack.Item>
        <Stack.Item key="cancel-button">
          <Button onClick={onCancel}>{i18n.getString(_TL_('Cancel'))}</Button>
        </Stack.Item>
      </Stack>
    </div>
  );
};

ActionBar.propTypes = {
  onAdd: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
